import { usePathname } from 'next/navigation';
import { type Dispatch, type SetStateAction, type FC } from 'react';
import { useSession } from 'next-auth/react';
import { Flex } from '@eqi-investimentos/react';
import { ContentMode, ContentModeEnum } from '../interface/Content';
import { appConfig } from '@/config/app';
import { AudioModeButton } from '@/components/elements/AudioModeButton';
import { SaveButton } from '@/components/elements/SaveButton';
import { ShareButton } from '@/components/elements/ShareButton';
import { VideoModeButton } from '@/components/elements/VideoModeButton';
import { IfRender } from '@/utils/jsx';

export const ContentActions: FC<ContentActionsProps> = ({
  mode = 'others',
  has_audio,
  has_video,
  isBookmarked,
  bookmarkContent,
  setContentMode,
}) => {
  const pathName = usePathname();
  const { data: session, status } = useSession();
  const hasSession = status === 'authenticated' && !session?.error;

  return (
    <Flex alignItems="center" gap="xl">
      <IfRender condition={mode === 'text'}>
        <IfRender condition={has_video}>
          <VideoModeButton
            onClick={() =>
              setContentMode ? setContentMode(ContentModeEnum.VIDEO) : undefined
            }
          />
        </IfRender>
        <IfRender condition={has_audio}>
          <AudioModeButton
            onClick={() =>
              setContentMode ? setContentMode(ContentModeEnum.AUDIO) : undefined
            }
          />
        </IfRender>
      </IfRender>
      <IfRender condition={hasSession}>
        <SaveButton
          bookmarked={isBookmarked}
          handleBookmark={bookmarkContent}
        />
      </IfRender>
      <ShareButton
        href={`${appConfig.appURL}${pathName}`.replaceAll('//', '/')}
      />
    </Flex>
  );
};

type ContentActionsProps = {
  mode: 'others' | 'text';
  has_audio: boolean;
  has_video: boolean;
  isBookmarked: boolean;
  bookmarkContent: () => void;
  setContentMode?: Dispatch<SetStateAction<ContentMode>>;
};
